<template>
	<div class="row teams-documents">
		<div class="col">
			<transition name="fade-documents">
				<div class="row" v-if="$root.documentsOpen">
					<div class="col gsap-fade-up team-all-documents">
						<div class="row">
							<div class="col">
								<div class="section__header">
									<p class="return" @click="$root.documentsOpen = false">Retour</p>
									<h1>Documents {{subsection.name}}</h1>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col p-0">
								<div v-if="!differentCategory" class="category-content" v-html="$root.juniorsSubCategory.content"></div>
								<div v-else class="category-content" v-html="subsection.content"></div>
							</div>
						</div>
					</div>
				</div>
			</transition>
			
			<div class="row" v-if="!$root.documentsOpen">
				<div class="col col-lg-6 col-xl-4">
					<div class="view-documents" @click="$root.documentsOpen = true">
						<p class="sub-info">Informations</p>
						<p class="main-info">Documents {{subsection.name}}</p>
						<p class="voir">Voir</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['subsection', 'differentCategory'],
	computed: {
		different() {
			return this.differentCategory
		}
	}
}
</script>

